import React, { useState, useEffect } from 'react';
import { getLocaleData, isEuEnv, LocaleData } from '@mb/lib/i18n';
import { IntlProvider } from 'react-intl';
import AutocompleteResultsContainer from './containers/AutocompleteResultsContainer/AutocompleteResultsContainer';
import SearchFormContainer from './containers/SearchFormContainer/SearchFormContainer';
import { shouldRenderSearchBar } from './helpers';
import { ProviderWrapper } from './ProviderWrapper';

// This component is used to display the search bar
const SearchBar: React.FC = () => {
  const [langData, setLangData] = useState<LocaleData>({
    currentLocale: 'en',
    messages: undefined,
  });

  useEffect(() => {
    handleLangData();
  }, []);

  const handleLangData = async () => {
    const data = await getLocaleData();
    if (isEuEnv) {
      setLangData(data);
    }
  };

  if (!shouldRenderSearchBar()) {
    return null;
  }

  return (
    <IntlProvider
      messages={langData?.messages}
      locale={langData?.currentLocale}
      defaultLocale="en"
    >
      <ProviderWrapper>
        <SearchFormContainer />
        <AutocompleteResultsContainer />
      </ProviderWrapper>
    </IntlProvider>
  );
};

export default SearchBar;
